import AdviceInvestmentTabs from './AdviceInvestmentTabs'
import DesktopTabs from './DesktopTabs'
import MobileTabs from './MobileTabs'

export default AdviceInvestmentTabs
export { DesktopTabs, MobileTabs }
